import Database from "./Database"

class WMBugs {
    report(report) {
        return Database.addOne("bug_reports", report)
    }
}

const Bugs = new WMBugs() 
export default Bugs